// src/components/SiteLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import '../App.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../Main.css';
import '../Megamenu.css';
import '../Style.css';
import '../Responsive.css';
import '../Sortcodes.css';
import '../Font-Awesome.css';
import '../Flaticon.css';
import '../Slick.css';
import '../themify-icons.css';
import Header from "./Header";
import Footer from "./Footer";


export default function SiteLayout() {
  return (
    <>
      <Header />
      <div className="Page">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
